/* DEX Homepage v2 · vanilla JS
   Handles: starfield, fade-in scroll, credential typing, 3D parallax.
   Scoped to [data-dex-hp="v2"]. Respects prefers-reduced-motion.
   Guard: registers editor events once; per-root init is idempotent. */
(function () {
  'use strict';

  if (window.__dexHpV2Registered) return;
  window.__dexHpV2Registered = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Shopify Theme Editor detection ─────────────────────────────────────── */
  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('dex-shopify-editor');
  }

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function getDexRoot(el) {
    if (!el || typeof el.querySelector !== 'function') return null;
    if (typeof el.matches === 'function' && el.matches('[data-dex-hp="v2"]')) return el;
    return el.querySelector('[data-dex-hp="v2"]');
  }

  /* ── Per-root idempotent initializer ─────────────────────────────────────── */
  function initDexHomepageV2(root) {
    if (root._dexCleanup) root._dexCleanup();

    root._dexInitialized = true;
    var timers    = [];
    var observers = [];

    root._dexCleanup = function () {
      timers.forEach(function (id) { clearInterval(id); clearTimeout(id); });
      observers.forEach(function (ob) { ob.disconnect(); });
      timers    = [];
      observers = [];
      root._dexInitialized = false;
      root._dexCleanup     = null;
    };

    /* ── STARFIELD ──────────────────────────────────────────────────── */
    qsa(root, '.starfield').forEach(function (container) {
      var motionOff = root.getAttribute('data-motion') === 'false';
      if (reduced || motionOff) return;
      if (container._dexStarsAdded) return;
      container._dexStarsAdded = true;
      var count = parseInt(container.getAttribute('data-star-count'), 10) || 70;
      var frag  = document.createDocumentFragment();
      for (var i = 0; i < count; i++) {
        var s   = document.createElement('span');
        var rnd = Math.random();
        var size  = rnd > 0.86 ? 2.5 : rnd > 0.55 ? 1.5 : 1;
        var delay = (Math.random() * 5).toFixed(2);
        var dur   = (4 + Math.random() * 6).toFixed(2);
        var op    = (0.25 + Math.random() * 0.60).toFixed(2);
        s.className = 'star';
        s.style.cssText =
          'width:'  + size + 'px;height:' + size + 'px;' +
          'top:'    + (Math.random() * 100).toFixed(2) + '%;' +
          'left:'   + (Math.random() * 100).toFixed(2) + '%;' +
          'animation-delay:' + delay + 's;' +
          'animation-duration:' + dur + 's;' +
          'opacity:' + op + ';';
        frag.appendChild(s);
      }
      container.appendChild(frag);
    });

    /* ── FADE-IN (IntersectionObserver) ─────────────────────────────── */
    (function () {
      var motionOff = root.getAttribute('data-motion') === 'false';
      var fadeEls   = qsa(root, '.fade-in');
      if (motionOff || reduced) {
        fadeEls.forEach(function (el) { el.classList.add('visible'); });
        return;
      }
      if ('IntersectionObserver' in window) {
        var fadeObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('visible');
              fadeObs.unobserve(e.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
        observers.push(fadeObs);
        fadeEls.forEach(function (el) { fadeObs.observe(el); });
      } else {
        fadeEls.forEach(function (el) { el.classList.add('visible'); });
      }
    }());

    /* ── CREDENTIAL CODE TYPING ─────────────────────────────────────── */
    qsa(root, '[data-type-code]').forEach(function (wrapper) {
      if (wrapper._dexTypeInit) return;
      wrapper._dexTypeInit = true;
      var full  = (wrapper.getAttribute('data-full') || '').trim();
      var typed = qs(wrapper, '.code-typed');
      var caret = qs(wrapper, '.type-caret');
      if (!full || !typed) return;

      if (reduced) {
        typed.textContent = full;
        if (caret) caret.style.display = 'none';
        return;
      }

      var i   = 0;
      var tid = setTimeout(function () {
        var itv = setInterval(function () {
          i++;
          typed.textContent = full.slice(0, i);
          if (i >= full.length) {
            clearInterval(itv);
            if (caret) setTimeout(function () { caret.style.display = 'none'; }, 900);
          }
        }, 70);
        timers.push(itv);
      }, 700);
      timers.push(tid);
    });

    /* ── HERO 3D PARALLAX ───────────────────────────────────────────── */
    if (!reduced) {
      var heroEl = qs(root, '.hero-v2');
      var visual = heroEl ? qs(heroEl, '.hero-visual') : null;
      var card   = visual ? qs(visual, '.cred-preview') : null;
      if (heroEl && visual && card &&
          !visual.hasAttribute('data-no-parallax') && !visual._dexParallaxAdded) {
        visual._dexParallaxAdded = true;
        var ticking = false;
        var cx = 0, cy = 0;
        visual.addEventListener('mousemove', function (e) {
          cx = e.clientX; cy = e.clientY;
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var r  = card.getBoundingClientRect();
            var x  = (cx - r.left) / r.width  - 0.5;
            var y  = (cy - r.top)  / r.height - 0.5;
            var ry = (-2 + x * 8).toFixed(2);
            var rx = ( 2 - y * 7).toFixed(2);
            card.style.transform =
              'perspective(1400px) rotateY(' + ry + 'deg) rotateX(' + rx + 'deg)';
            ticking = false;
          });
        });
        visual.addEventListener('mouseleave', function () {
          card.style.transition = 'transform 600ms cubic-bezier(0.22,1,0.36,1)';
          card.style.transform  = 'perspective(1400px) rotateY(-2deg) rotateX(2deg)';
          setTimeout(function () { card.style.transition = ''; }, 650);
        });
      }
    }

    /* ── COUNT-UP (Phase 2) ─────────────────────────────────────────── */
    if ('IntersectionObserver' in window) {
      var countMotionOff = root.getAttribute('data-motion') === 'false';
      qsa(root, '.count-up[data-to]').forEach(function (el) {
        if (el._dexCountFired) return;
        var to  = parseFloat(el.getAttribute('data-to'))  || 0;
        var dur = parseFloat(el.getAttribute('data-dur'))  || 1100;
        var countObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            countObs.disconnect();
            el._dexCountFired = true;
            if (reduced || countMotionOff) { el.textContent = Math.round(to); return; }
            var start = performance.now();
            (function step(now) {
              var t     = Math.min(1, (now - start) / dur);
              var eased = 1 - Math.pow(1 - t, 3);
              el.textContent = Math.round(to * eased);
              if (t < 1) requestAnimationFrame(step);
            })(start);
          });
        }, { threshold: 0.4 });
        observers.push(countObs);
        countObs.observe(el);
      });
    }

    /* ── PERSONA CAROUSEL (Phase 2) ─────────────────────────────────── */
    (function () {
      var section     = qs(root, '.persona');
      if (!section) return;

      var quotes      = qsa(section, '[data-persona-quote]');
      var portrait    = qs(section, '.persona-portrait');
      var frameTag    = portrait ? qs(portrait, '.frame-tag span:last-child') : null;
      var portraitImg = portrait ? qs(portrait, '.persona-portrait-img') : null;
      var portraitPh  = portrait ? qs(portrait, '[data-persona-placeholder]') : null;
      var dots        = qsa(section, '.persona-dot');
      var prevBtn     = qs(section, '[data-persona-prev]');
      var nextBtn     = qs(section, '[data-persona-next]');
      var quoteEl     = qs(section, '.persona-quote');
      var countEl     = qs(section, '.persona-count-num');
      if (!quoteEl || !quotes.length) return;

      var container  = qs(section, '[data-autoplay-speed]') || section;
      var autoplayOn = container.getAttribute('data-autoplay') !== 'false';
      var autoplayMs = parseInt(container.getAttribute('data-autoplay-speed'), 10) || 5400;
      var total  = quotes.length;
      var cur    = 0;
      var paused = false;
      var timer  = null;

      /* Section-level fallback image data */
      var fallbackSrc = portrait ? (portrait.getAttribute('data-fallback-src') || '') : '';
      var fallbackAlt = portrait ? (portrait.getAttribute('data-fallback-alt') || 'Persona image') : 'Persona image';
      var fallbackPos = portrait ? (portrait.getAttribute('data-fallback-pos') || 'center') : 'center';
      var showPh      = portrait ? (portrait.getAttribute('data-show-placeholder') !== 'false') : false;

      function updatePortrait(q) {
        if (!portraitImg) return;
        var imgSrc = q ? (q.getAttribute('data-persona-img')     || '') : '';
        var imgAlt = q ? (q.getAttribute('data-persona-img-alt') || '') : '';
        var imgPos = q ? (q.getAttribute('data-persona-img-pos') || 'center') : 'center';
        var src = imgSrc || fallbackSrc;
        var alt = imgAlt || fallbackAlt;
        var pos = imgSrc ? imgPos : fallbackPos;
        if (src) {
          portraitImg.src                  = src;
          portraitImg.alt                  = alt;
          portraitImg.style.objectPosition = pos;
          portraitImg.style.display        = '';
          if (portraitPh) portraitPh.style.display = 'none';
        } else {
          portraitImg.style.display = 'none';
          if (portraitPh && showPh) portraitPh.style.display = '';
        }
      }

      function show(idx, animate) {
        cur = (idx + total) % total;
        var q     = quotes[cur];
        var txt   = q ? (q.getAttribute('data-persona-quote')     || '') : '';
        var who   = q ? (q.getAttribute('data-persona-who')       || '') : '';
        var badge = q ? (q.getAttribute('data-persona-img-badge') || '') : '';
        if (animate && !reduced) {
          quoteEl.classList.add('dex-fade-out');
          setTimeout(function () {
            quoteEl.textContent = txt;
            quoteEl.classList.remove('dex-fade-out');
          }, 200);
        } else {
          quoteEl.textContent = txt;
        }
        if (frameTag) frameTag.textContent = badge || who;
        if (countEl)  countEl.textContent  = String(cur + 1).padStart(2, '0');
        dots.forEach(function (d, i) { d.classList.toggle('active', i === cur); });
        updatePortrait(q);
      }

      function startTimer() {
        if (reduced || !autoplayOn) return;
        if (timer) clearInterval(timer);
        timer = setInterval(function () { if (!paused) show(cur + 1, true); }, autoplayMs);
        timers.push(timer);
      }

      show(0, false);
      startTimer();

      /* Desktop hover: pause only on pointer-hover-capable devices.
         On touch-primary devices mouseenter fires on tap but mouseleave
         never follows, leaving paused = true permanently. */
      var canHover = window.matchMedia ? window.matchMedia('(hover: hover)').matches : true;
      if (canHover) {
        section.addEventListener('mouseenter', function () { paused = true; });
        section.addEventListener('mouseleave', function () { paused = false; });
      }

      /* Mobile touch: brief pause while finger is down, resume 2 s after lift */
      var touchResumeId = null;
      section.addEventListener('touchstart', function () {
        paused = true;
        if (touchResumeId) clearTimeout(touchResumeId);
      }, { passive: true });
      section.addEventListener('touchend', function () {
        if (touchResumeId) clearTimeout(touchResumeId);
        touchResumeId = setTimeout(function () { paused = false; }, 2000);
        timers.push(touchResumeId);
      }, { passive: true });

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { show(i, true); startTimer(); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { show(cur - 1, true); startTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(cur + 1, true); startTimer(); });
    }());

    /* ── PILLARS TAB SWITCHER (Phase 2) ─────────────────────────────── */
    (function () {
      var section = qs(root, '[data-pillars]');
      if (!section) return;

      var pillarsAutoplay   = section.getAttribute('data-autoplay') !== 'false';
      var pillarsAutoplayMs = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 4800;
      var tabs      = qsa(section, '.pillar-tab');
      var panels    = qsa(section, '.pillar-panel[data-tab]');
      var cur       = 0;
      var scenTimer = null;

      function startScenarios(panel) {
        if (scenTimer) { clearInterval(scenTimer); scenTimer = null; }
        if (!panel) return;
        var scens = qsa(panel, '[data-scenario]');
        var pips  = qsa(panel, '.pillar-pip');
        var scEl  = qs(panel, '.pillar-scenario');
        if (!scEl || !scens.length) return;
        var si = 0;

        function showScen(i, animate) {
          si  = (i + scens.length) % scens.length;
          var txt = scens[si] ? (scens[si].getAttribute('data-scenario') || '') : '';
          if (animate && !reduced) {
            scEl.classList.add('dex-fade-out');
            setTimeout(function () {
              scEl.textContent = txt;
              scEl.classList.remove('dex-fade-out');
            }, 150);
          } else {
            scEl.textContent = txt;
          }
          pips.forEach(function (p, j) { p.classList.toggle('active', j === si); });
        }

        pips.forEach(function (p, j) {
          p.addEventListener('click', function () {
            showScen(j, true);
            clearInterval(scenTimer);
            if (!reduced && pillarsAutoplay) {
              scenTimer = setInterval(function () { showScen(si + 1, true); }, pillarsAutoplayMs);
              timers.push(scenTimer);
            }
          });
        });

        showScen(0, false);
        if (!reduced && pillarsAutoplay) {
          scenTimer = setInterval(function () { showScen(si + 1, true); }, pillarsAutoplayMs);
          timers.push(scenTimer);
        }
      }

      function showTab(idx) {
        cur = idx;
        tabs.forEach(function (t, i) {
          t.classList.toggle('active', i === idx);
          t.setAttribute('aria-selected', String(i === idx));
        });
        panels.forEach(function (p, i) { p.style.display = i === idx ? '' : 'none'; });
        startScenarios(panels[idx]);
      }

      tabs.forEach(function (t, i) { t.addEventListener('click', function () { showTab(i); }); });
      showTab(0);
    }());

    /* ── SAMPLE QUESTION (Phase 2) ──────────────────────────────────── */
    (function () {
      var card = qs(root, '.sample-card');
      if (!card) return;

      var opts          = qsa(card, '.sample-opt');
      var footResult    = qs(card, '.sample-foot-result');
      var correctLetter = card.getAttribute('data-correct-letter') || 'C';

      opts.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var isBest = btn.getAttribute('data-best') === 'true';
          opts.forEach(function (o) { o.classList.remove('selected', 'wrong-answer', 'is-best'); });
          opts.forEach(function (o) {
            if (o.getAttribute('data-best') === 'true') o.classList.add('is-best');
          });
          btn.classList.add('selected');
          if (!isBest) btn.classList.add('wrong-answer');
          if (footResult) {
            if (isBest) {
              footResult.innerHTML = '<span class="sample-result-ok">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
                ' Best answer</span>';
            } else {
              footResult.innerHTML = '<span class="sample-result-err">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
                ' See option ' + correctLetter + '</span>';
            }
          }
        });
      });
    }());

    /* ── REGISTRY ANIMATION (Phase 3) ──────────────────────────────── */
    if ('IntersectionObserver' in window) {
      (function () {
        var motionOff = root.getAttribute('data-motion') === 'false';
        var section   = qs(root, '.registry');
        if (!section) return;
        var browser   = qs(section, '.reg-browser');
        var inputEl   = qs(section, '.reg-search-input');
        var btn       = qs(section, '.reg-search-btn');
        var resultEl  = qs(section, '.reg-result');
        var verifyBtn = qs(section, '.reg-verify-btn');
        if (!browser || !inputEl || !btn || !resultEl) return;
        var codeStr = inputEl.getAttribute('data-code') || 'ASKF-ORDE-XCAN-ABCD';
        var fired   = false;

        function runRegAnim() {
          if (reduced || motionOff) {
            inputEl.value = codeStr;
            resultEl.classList.remove('is-hidden');
            return;
          }
          inputEl.value = '';
          resultEl.classList.add('is-hidden');
          btn.classList.remove('is-loading');
          var i  = 0;
          var t1 = setTimeout(function () {
            var itv = setInterval(function () {
              i++;
              inputEl.value = codeStr.slice(0, i);
              if (i >= codeStr.length) {
                clearInterval(itv);
                var t2 = setTimeout(function () {
                  btn.classList.add('is-loading');
                  var t3 = setTimeout(function () {
                    btn.classList.remove('is-loading');
                    resultEl.classList.remove('is-hidden');
                    resultEl.classList.add('is-flash');
                    setTimeout(function () { resultEl.classList.remove('is-flash'); }, 900);
                  }, 950);
                  timers.push(t3);
                }, 300);
                timers.push(t2);
              }
            }, 70);
            timers.push(itv);
          }, 600);
          timers.push(t1);
        }

        var regObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !fired) {
              fired = true; regObs.disconnect(); runRegAnim();
            }
          });
        }, { threshold: 0.20 });
        observers.push(regObs);
        regObs.observe(browser);

        if (verifyBtn) {
          verifyBtn.addEventListener('click', function () {
            verifyBtn.classList.add('is-verifying');
            setTimeout(function () { verifyBtn.classList.remove('is-verifying'); }, 1500);
            runRegAnim();
          });
        }
      }());
    }

    /* ── FAQ ACCORDION (Phase 3) ─────────────────────────────────────── */
    qsa(root, '.faq-list').forEach(function (list) {
      var items = qsa(list, '.faq-item');
      items.forEach(function (item) {
        var btn = qs(item, '.faq-q-btn');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('open');
          items.forEach(function (it) {
            it.classList.remove('open');
            var b = qs(it, '.faq-q-btn');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  /* ── Bootstrap ───────────────────────────────────────────────────────────── */
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    qsa(document, '[data-dex-hp="v2"]').forEach(initDexHomepageV2);
  });

  /* ── Shopify Theme Editor events ─────────────────────────────────────────── */
  document.addEventListener('shopify:section:load', function (e) {
    var root = getDexRoot(e.target);
    if (root) initDexHomepageV2(root);
  });

  document.addEventListener('shopify:section:select', function (e) {
    var root = getDexRoot(e.target);
    if (root && !root._dexInitialized) initDexHomepageV2(root);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest ? e.target.closest('[data-dex-hp="v2"]') : null;
    if (root && !root._dexInitialized) initDexHomepageV2(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = getDexRoot(e.target);
    if (root && root._dexCleanup) root._dexCleanup();
  });

}());
